export default {
  mounted() {
    if (process.env.NODE_ENV === 'development') {
      document.body.setAttribute('dev-mode', '');
    }
  }
};
